import { createContext } from "react";
import { StoreApi } from "zustand";

import { ActivityTabsStoreType } from "./activity_tabs_store.types";

type ActivityTabsStoreContextType = StoreApi<ActivityTabsStoreType>;

export const ActivityTabsStoreContext = createContext<ActivityTabsStoreContextType>(
  {} as ActivityTabsStoreContextType
);
